import { ZoomConfig } from '../lib/zoomValidation';
import { anyType } from '../types';
import { DataType } from '../types/lib/types';
import { UrlsDataType } from '../types/lib/useGetTileUrls';
import { replaceStrArr } from './formatedText';
import { getFeatureArrData } from './getFeatures';
import { LAYER_GEOMETRY_TYPES } from './smartCityStyle';
import { areAllPrintZoomValuesUnique, checkZoomRanges } from './zoomValidation';

type UpdateFilteredFeaturesParams = {
    map: anyType,
    menuItem: DataType[] | undefined,
    dataPngUrls: UrlsDataType[],
    vectorTileUrls: UrlsDataType[],
    hasZoomConfIdsObj: { [key: string]: ZoomConfig } | undefined,
    setFilterdFeatureIds: React.Dispatch<React.SetStateAction<string[]>>,
    setZoomErrMsg: React.Dispatch<React.SetStateAction<string | undefined>>,
    setNowZoom: React.Dispatch<React.SetStateAction<number | undefined>>,
    setMeasureObj: (value: React.SetStateAction<{
        label: string;
        value: number;
        isShow: boolean;
    }[]>) => void,
    measureObj: anyType[],
    baseMapZoom: string[],
};

export type UpdateFilteredFeaturesResult = {
    filterdFeatureIds: string[];
    zoomErrMsg: string | undefined;
    measureObj: { label: string; value: number; isShow: boolean }[];
    hasZoomConfIdsObjCurrent?: { [key: string]: ZoomConfig } | undefined;
};

export const updateFilteredFeatures = async ({
    map,
    menuItem,
    dataPngUrls,
    vectorTileUrls,
    hasZoomConfIdsObj,
    measureObj,
    baseMapZoom,
}: Omit<UpdateFilteredFeaturesParams,
    'setFilterdFeatureIds' | 'setZoomErrMsg' | 'setNowZoom' | 'setMeasureObj'
>): Promise<UpdateFilteredFeaturesResult> => {

    if (hasZoomConfIdsObj) {
        return {
            filterdFeatureIds: [],
            hasZoomConfIdsObjCurrent: hasZoomConfIdsObj,
            zoomErrMsg: undefined,
            measureObj
        };
    }

    const features = await getFeatureArrData(map, undefined, menuItem, dataPngUrls, vectorTileUrls);
    const hasZoomConfObj: { [key: string]: ZoomConfig } = {};
    let formatFeatureArr: string[] = [];

    if (features) {
        const featureArr = Object.values(features).reduce((acc, val) => acc.concat(val), []);
        formatFeatureArr = Array.from(new Set(featureArr.map((feature: anyType) => feature.layer.id)));

        if (formatFeatureArr.length === 0) {
            return {
                filterdFeatureIds: [],
                zoomErrMsg: undefined,
                measureObj,
                hasZoomConfIdsObjCurrent: undefined
            };
        }

        formatFeatureArr.forEach((id: string) => {
            const formatedId = replaceStrArr(id, Object.values(LAYER_GEOMETRY_TYPES), '');
            if (!(formatedId in hasZoomConfObj)) {
                const target = menuItem?.find((item) => {
                    const meta = item.metadata;
                    return item.id === formatedId && meta && ('printzoom' in meta || 'minzoom' in meta || 'maxzoom' in meta);
                });
                if (target) {
                    hasZoomConfObj[formatedId] = {
                        printzoom: target.metadata?.printzoom.split(','),
                        minzoom: target.metadata?.minzoom,
                        maxzoom: target.metadata?.maxzoom
                    };
                }
            }
        });
    }

    let hasZoomConfIdsObjCurrent: { [key: string]: ZoomConfig; } | undefined = { ...hasZoomConfObj }
    if (baseMapZoom.length > 0) {
        hasZoomConfIdsObjCurrent['baseMap'] = { printzoom: baseMapZoom };
    }

    if(Object.keys(hasZoomConfIdsObjCurrent).length === 0) {
        hasZoomConfIdsObjCurrent = undefined;
    }

    if (!hasZoomConfIdsObjCurrent || Object.keys(hasZoomConfIdsObjCurrent).length === 0) {
        return {
            filterdFeatureIds: formatFeatureArr,
            zoomErrMsg: undefined,
            measureObj,
            hasZoomConfIdsObjCurrent
        };
    }

    if (
        Object.keys(hasZoomConfIdsObjCurrent).length > 0 &&
        (areAllPrintZoomValuesUnique(hasZoomConfIdsObjCurrent) ||
            checkZoomRanges(hasZoomConfIdsObjCurrent, measureObj))
    ) {
        return {
            filterdFeatureIds: formatFeatureArr,
            zoomErrMsg: '選択したデータの一部が、現在の表示範囲に収まりません。以下の印刷時縮尺を確認し、データの組み合わせを調整して再度お試しください。',
            measureObj,
            hasZoomConfIdsObjCurrent
        };
    } else {
        // ズームを固定する
        const target = hasZoomConfIdsObjCurrent[Object.keys(hasZoomConfIdsObjCurrent)[0]];
        const nowZoom = map.getZoom();

        if (target.minzoom && nowZoom < target.minzoom) {
            return {
                filterdFeatureIds: formatFeatureArr,
                zoomErrMsg: undefined,
                measureObj,
                hasZoomConfIdsObjCurrent
            };
        } else if (target.maxzoom && nowZoom > target.maxzoom) {
            return {
                filterdFeatureIds: formatFeatureArr,
                zoomErrMsg: undefined,
                measureObj,
                hasZoomConfIdsObjCurrent
            };
        } else if (target.printzoom) {
            const res = measureObj.filter((measure) => target.printzoom?.includes(measure.label))
                .map((item) => { return { ...item, isShow: true } });

            if (res.length > 0) {
                return {
                    filterdFeatureIds: formatFeatureArr,
                    zoomErrMsg: undefined,
                    measureObj: res,
                    hasZoomConfIdsObjCurrent
                };
            }
            return {
                filterdFeatureIds: formatFeatureArr,
                zoomErrMsg: undefined,
                measureObj: res,
                hasZoomConfIdsObjCurrent
            };
        }
    }
    return {
        filterdFeatureIds: formatFeatureArr,
        zoomErrMsg: undefined,
        measureObj,
        hasZoomConfIdsObjCurrent
    };
};
